import React from 'react';
import { ArrowIcon, DemoContent, DemoProductButton, DemoProducts, ExitButton } from './styles';
import { RouteComponentProps, withRouter } from 'react-router';
import ProductPOSSrc from '~Assets/icons/product_point-of-sale.svg';
import ProductTSRSrc from '~Assets/icons/product_table-management.svg';
import ArrowSrc from '~Assets/icons/arrow_forward_grey.svg';
import * as actions from '../../actions';
import { useDispatch } from 'react-redux';
import { useI18n } from '~Hooks';
import { useStorage } from '~Components/Storage';

type Props = RouteComponentProps;

const DemoIntro = (props: Props) => {
  const [, , venueId] = props.location.pathname.split('/');
  const dispatch = useDispatch();
  const { i18n } = useI18n();
  const [, updateStorage] = useStorage();

  const exitDemoMode = () => {
    dispatch(actions.setDemoMode(false));
    dispatch({
      type: 'SET_POS_LAYOUT',
      POSLayout: null,
    });
    updateStorage({ hideDemoMode: true });
  };

  return (
    <DemoContent>
      <h1>{i18n('DemoMode.Title')}</h1>
      <p>{i18n('DemoMode.Text')}</p>

      <DemoProducts>
        <DemoProductButton to={`/venue/${venueId}/pos`}>
          <img src={ProductPOSSrc} width="40px" />
          <span>{i18n('DemoMode.Products.POS.Title')}</span>
          <em>{i18n('DemoMode.Products.POS.Description')}</em>
          <ArrowIcon src={ArrowSrc} />
        </DemoProductButton>
        <DemoProductButton to={`/venue/${venueId}/tables`}>
          <img src={ProductTSRSrc} width="40px" />
          <span>{i18n('DemoMode.Products.TSR.Title')}</span>
          <em>{i18n('DemoMode.Products.TSR.Description')}</em>
          <ArrowIcon src={ArrowSrc} />
        </DemoProductButton>
      </DemoProducts>
      <ExitButton onClick={exitDemoMode}>{i18n('DemoMode.ExitMode')}</ExitButton>
    </DemoContent>
  );
};

export default withRouter(DemoIntro);
